import { Step } from "../../../types/Step";
import { View } from "../../../types/Views";
import IUserEvent from "../../types/IUserEvent";
import StepArrivalUserEvent from "../../types/StepArrivalUserEvent";
import ViewArrivalUserEvent from "../../types/ViewArrivalUserEvent";

const StepOrViewArrivedEventFactory = (eventData: string): IUserEvent<Step | View> => {
  try {
    return new StepArrivalUserEvent(eventData);
  } catch {
    return new ViewArrivalUserEvent(eventData);
  }
};

export default StepOrViewArrivedEventFactory;
